import React from 'react';

interface CptRow {
  relativeWeight?: number | null;
}

/**
 * Weight template with 4 decimal places
 */
export const WeightTemplate: React.FC<{ weight: number | null | undefined }> = ({ weight }) => {
  const value = weight ?? 0;
  return <span>{value ? value.toFixed(4) : 'N/A'}</span>;
};

// Template function for grid column
export const weightTemplate = (props: CptRow) => <WeightTemplate weight={props.relativeWeight} />;

export default WeightTemplate;
